import { render } from "./EmailSendButton.vue?vue&type=template&id=64715667&scoped=true"
import script from "./EmailSendButton.vue?vue&type=script&lang=js"
export * from "./EmailSendButton.vue?vue&type=script&lang=js"

import "./EmailSendButton.vue?vue&type=style&index=0&id=64715667&scoped=true&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64715667"]])

export default __exports__